import React, { useEffect, useState } from "react";
import { Button, Form, InputNumber, Select } from "antd";
import { DELIVERY_CYCLE_OPTIONS } from "@/constants/util";

const formItemLayout = {
  labelCol: {
    sm: { span: 12 },
  },
  wrapperCol: {
    sm: { span: 12 },
  },
};

const Cycle = (props) => {
  const { onChange = () => {}, cycleData = [] } = props;

  const [cycles, setCycles] = useState([]);

  const handleChangeCycle = (value, index, key) => {
    const current = cycles[index];
    cycles.splice(index, 1, { ...current, [key]: value });
    setCycles([...cycles]);
  };

  useEffect(() => {
    setCycles([{ cycle: undefined, pointPrice: 1, advertisementPrice: 1 }]);
  }, []);

  useEffect(() => {
    onChange(cycles);
  }, [cycles]);

  const handleAddCycle = () => {
    cycles.push({ cycle: undefined, pointPrice: 1, advertisementPrice: 1 });
    setCycles([...cycles]);
  };

  const handleDeleteCycle = (index) => {
    cycles.splice(index, 1);
    setCycles([...cycles]);
  };

  const cycleData_option = cycleData.map((item) => ({
    value: item.cycle,
    label: `${item.cycle}天`,
  }));

  return (
    <div className="cycle">
      {cycles.map((cycle, index) => (
        <div className="cycle-item" key={index}>
          <Form.Item label="投放周期" {...formItemLayout} required>
            <Select
              style={{ width: 97 }}
              placeholder={"投放周期"}
              value={cycle.cycle}
              onChange={(value) => handleChangeCycle(value, index, "cycle")}
            >
              {cycleData_option.map((cycle) => (
                <Select.Option value={cycle.value} key={cycle.value}>
                  {cycle.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="点位费用" {...formItemLayout} required>
            <InputNumber
              style={{ width: 97 }}
              placeholder="输入费用"
              value={cycle.pointPrice}
              formatter={(value) => `${value}元`}
              parser={(value) => value.replace("元", "")}
              onChange={(value) =>
                handleChangeCycle(value, index, "pointPrice")
              }
              min={0}
            />
          </Form.Item>
          <Form.Item label="屏保费用" {...formItemLayout} required>
            <InputNumber
              style={{ width: 97 }}
              placeholder="输入费用"
              formatter={(value) => `${value}元`}
              parser={(value) => value.replace("元", "")}
              value={cycle.advertisementPrice}
              onChange={(value) =>
                handleChangeCycle(value, index, "advertisementPrice")
              }
              min={0}
            />
          </Form.Item>
          {index === 0 ? (
            <Button
              type="primary"
              style={{ marginTop: 4 }}
              onClick={handleAddCycle}
            >
              添加周期
            </Button>
          ) : (
            <Button
              type="danger"
              style={{ marginTop: 4 }}
              onClick={() => handleDeleteCycle(index)}
              ghost
            >
              删除周期
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default Cycle;
